<template>
    <b-modal id="modal-children-privacy-protection" no-close-on-backdrop centered hide-header hide-footer>
        <div class="children-privacy-protection">
        <div class="children-privacy-protection-header">
            <h2>Why are we asking for your birthday?</h2>
            <p>The U.S. Children's Online Privacy Protection Act (COPPA) requires users to be over 13 years of age to access our app, so we are introducing a system to verify that users satisfy that minimum age requirement. We do this to keep our users safe and ensure they encounter material that's appropriate for them.</p>
        </div>
        <div class="children-privacy-protection-button">
            <b-button @click="$bvModal.hide('modal-children-privacy-protection')" variant="primary">
                Got it!
            </b-button>
        </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "ChildrenPrivacyProtection"
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .children-privacy-protection
        padding-top 170px
        padding-bottom 100px

        &-header
            padding-bottom 15px
            &>*
                text-align center
            h2
                font font-poppins-semibold
                font-size 21px
                color color-black

            p
                font font-sourcesans-regular
                font-size 16px
                color color-brown

        &-button
            button
                width 100%

</style>
